export { default } from './InputRadio';
